import React from 'react'
import {
  StyledP,
  ErrorText,
  Wrapper,
} from 'modules/Students/Partials/StudentsBulkUpload/Partials/ErrorInfoTable/Style/style'
import { StyledTable } from 'components/TableStyles/TableStyles'

const ErrorInfoTable = ({ data }) => {
  const columns = [
    {
      title: 'Student Name',
      dataIndex: 'firstName',
      render: (text, item) => (
        <StyledP>
          {item['First Name']} {item['Last Name']}
        </StyledP>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'Primary Email',
      render: (text, item) => <StyledP>{item['Primary Email']}</StyledP>,
    },
    {
      title: 'Error',
      dataIndex: 'error',
      render: (text, item) => <ErrorText>{text}</ErrorText>,
    },
  ]
  return (
    <Wrapper>
      <StyledTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{ position: ['none'] }}
      />
    </Wrapper>
  )
}

export default ErrorInfoTable
